// extracted by mini-css-extract-plugin
export default {"container":"OperationResult_container__gtp9M","container_error":"OperationResult_container_error__QZpab","return_btn":"OperationResult_return_btn__qqC2R"};